module.exports = __webpack_public_path__ + "images/f695b3d7a5926fee827ce06f0696bfd0-VisitIceland_Wordmark_RGB-1.png";